import React from 'react';
import {motion} from 'framer-motion';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import ProductInfo from '../components/ProductInfo';
import TechnicalSpecs from '../components/TechnicalSpecs';
import Installation from '../components/Installation';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <motion.div 
      className="min-h-screen bg-white text-gray-900"
      initial={{opacity: 0}} 
      animate={{opacity: 1}} 
      transition={{duration: 0.8}}
    >
      <Header />
      <Hero />
      <Features />
      <ProductInfo />
      <TechnicalSpecs />
      <Installation />
      <Contact />
      <Footer />
    </motion.div>
  );
};

export default LandingPage;